import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { authInstance, decodeJwt, type Token } from "../utils";

interface JwtState {
    token: Token;
    decodedJwt: Record<string, unknown> | null;
    userId: number | null;
    setJwt: (jwt: Token) => void;
}

export const useJwt = create<JwtState>()(
    subscribeWithSelector((set) => ({
        token: undefined,
        decodedJwt: null,
        userId: null,
        setJwt: (token: Token) => set({ token }),
    })),
);

export const useIsAuthenticated = () => useJwt((state) => typeof state.token === "string");

export const useIsLoggedOut = () => useJwt((state) => state.token === null);

export const useIsAuthLoading = () => useJwt((state) => state.token === undefined);

authInstance.addStateChangeListener(({ token }) => {
    useJwt.getState().setJwt(token);
});

useJwt.subscribe(
    (state) => state.token,
    (token) => {
        if (token) {
            const decoded = decodeJwt(token);
            const userId = decoded?.sub ? Number(decoded.sub) : null;

            useJwt.setState({ decodedJwt: decoded, userId });
            return;
        }

        if (token === null) {
            useJwt.setState({ decodedJwt: null, userId: null });
        }
    },
);
